export default __webpack_public_path__ + "static/ticketMail-12243175b9a319663b5d2670b13cc2eb.png";